import { iposRoutes } from "../../../routes/RoutesMap";

export const INDEX_PATH: string = iposRoutes.INDEX.createLink();
export const FTTB_FLOW_PATH: string = iposRoutes.FTTB_FLOW.createLink();
export const FTTB_FLOW_ADDRESS_PATH: string = iposRoutes.FTTB_FLOW_ADDRESS.createLink();
export const FTTB_FLOW_PLAN_PATH: string = iposRoutes.FTTB_FLOW_PLAN.createLink();
export const FTTB_FLOW_OPTIONS_PATH: string = iposRoutes.FTTB_FLOW_OPTIONS.createLink();
export const FTTB_FLOW_SUMMARY_PATH: string = iposRoutes.FTTB_FLOW_SUMMARY.createLink();